var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.822 8.30012C21.73 8.16719 21.6072 8.05854 21.464 7.98348C21.3209 7.90842 21.1616 7.86918 21 7.86912H7.333L6.179 5.09912C6.02769 4.73434 5.77147 4.42271 5.44282 4.20373C5.11418 3.98476 4.72791 3.8683 4.333 3.86912H2V5.86912H4.333L9.077 17.2541C9.15299 17.4363 9.28118 17.5919 9.44542 17.7013C9.60967 17.8108 9.80263 17.8691 10 17.8691H18C18.417 17.8691 18.79 17.6101 18.937 17.2211L21.937 9.22112C21.9937 9.06974 22.0129 8.90688 21.9928 8.74647C21.9728 8.58607 21.9142 8.43291 21.822 8.30012V8.30012Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.8691C11.3284 21.8691 12 21.1976 12 20.3691C12 19.5407 11.3284 18.8691 10.5 18.8691C9.67157 18.8691 9 19.5407 9 20.3691C9 21.1976 9.67157 21.8691 10.5 21.8691Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.8691C18.3284 21.8691 19 21.1976 19 20.3691C19 19.5407 18.3284 18.8691 17.5 18.8691C16.6716 18.8691 16 19.5407 16 20.3691C16 21.1976 16.6716 21.8691 17.5 21.8691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.0d48048495db2fccd1f51c5cd92cbea4.svg";
export { ForwardRef as ReactComponent };